var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuditIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 26,
    fill: "#F4F7FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.457 34.0625C36.457 34.278 36.3714 34.4847 36.2191 34.637C36.0667 34.7894 35.86 34.875 35.6445 34.875H16.1445C15.929 34.875 15.7224 34.7894 15.57 34.637C15.4176 34.4847 15.332 34.278 15.332 34.0625V17.8125C15.332 17.597 15.4176 17.3903 15.57 17.238C15.7224 17.0856 15.929 17 16.1445 17C16.36 17 16.5667 17.0856 16.7191 17.238C16.8714 17.3903 16.957 17.597 16.957 17.8125V27.397L22.1093 22.8906C22.2495 22.7679 22.4276 22.6971 22.6138 22.6901C22.8 22.683 22.983 22.7402 23.132 22.852L29.1049 27.332L35.1093 22.0781C35.188 22.0002 35.2819 21.9392 35.385 21.8988C35.4882 21.8585 35.5985 21.8397 35.7092 21.8436C35.8199 21.8474 35.9287 21.8739 36.0288 21.9213C36.1289 21.9687 36.2183 22.0361 36.2914 22.1194C36.3645 22.2026 36.4198 22.2999 36.4539 22.4053C36.488 22.5107 36.5002 22.6219 36.4898 22.7322C36.4793 22.8425 36.4464 22.9495 36.3931 23.0466C36.3398 23.1437 36.2672 23.2289 36.1798 23.2969L29.6798 28.9844C29.5396 29.1071 29.3614 29.1779 29.1752 29.1849C28.989 29.192 28.8061 29.1348 28.657 29.023L22.6841 24.5451L16.957 29.5562V33.25H35.6445C35.86 33.25 36.0667 33.3356 36.2191 33.488C36.3714 33.6403 36.457 33.847 36.457 34.0625Z",
    fill: "#0066CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuditIcon);
export default __webpack_public_path__ + "static/media/auditIcon.d073f92a806a5c4a321272d247fb9a3a.svg";
export { ForwardRef as ReactComponent };